export const FETCH_FEATURE_STATUS_CALL_SUCCESS = "FETCH_FEATURE_STATUS_CALL_SUCCESS";

/**
 * Fetch feature status call success.
 */
export const fetchFeatureStatusCallSuccess = featureStatus => ({
    type: FETCH_FEATURE_STATUS_CALL_SUCCESS,
    featureStatus
});



// WEBPACK FOOTER //
// ./src/actions/ConfigActions.js